import React, { FC } from 'react';
import { useAppSelector } from '../../../../stores/redux-store';
import { DuplicatePaymentErrorScreen } from './DuplicatePaymentErrorScreen';

export const DuplicatePaymentErrorScreenWrapper: FC = ({ children }) => {
  const duplicateError = useAppSelector((state) => state.paymentDetails.duplicatePaymentState);

  if (duplicateError) {
    return <DuplicatePaymentErrorScreen error={duplicateError} />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
